module.exports = __webpack_public_path__ + "img/IO.6c533de1.png";